import React, { useEffect, useState, useMemo } from "react";
import { useHistory, Route, Switch, useRouteMatch } from "react-router-dom";
import { useIntl } from "react-intl";
import { VStack } from "@chakra-ui/react";
import { FraudCheck } from "components/FraudCheck";
import { Fraudnet } from "components/Paypal";
import { IframeOrFullPageWrapper } from "components/Container";
import { AddPaymentMethodContent } from "components/AddPaymentMethod";
import { getFinalConfig, FLOW_STATE, noop } from "utils";
import { CHECKOUT } from "flows/constants";
import CheckoutContainer from "./CheckoutContainer";
import Header from "flows/components/Header";

const defaultChooserConfig = {
  chooser: {
    include: [],
    exclude: [],
    addCC: true,
    addPaypal: true,
  },
};

/**
 * Checkout
 * @param {CheckoutProps} props
 * @returns JSX.Element
 */
export const Checkout = ({ onComplete, onReady, config, ...rest }) => {
  useEffect(() => {
    // On mount, we call `onReady` right away, since this flow has its own way
    // of handling loading states. TODO: Might be worth looking into refactoring
    // this later on and not having side effects crossing between flows.
    onReady({ state: FLOW_STATE.READY });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();
  const { path } = useRouteMatch();

  const { formatMessage } = useIntl();

  const [viewedAddPM, setViewedAddPM] = useState(false);

  const { chooser: chooserConfig } = useMemo(
    () => getFinalConfig(CHECKOUT, defaultChooserConfig, config),
    [config]
  );

  const handleCancel = () => {
    onComplete({ state: FLOW_STATE.CANCEL });
  };

  const onAddPMOpen = () => {
    history.push(`${path}/addpm`);
    if (!viewedAddPM) {
      setViewedAddPM(true);
    }
  };

  const onAddPMClose = () => {
    history.push(path);
  };

  // turn off header cancel button while and after submitting
  const [isCancellable, setCancellable] = useState(true);
  const handleSubmitting = (submitting) => setCancellable(!submitting);

  return (
    <IframeOrFullPageWrapper>
      <FraudCheck isAsync />
      <Fraudnet onComplete={noop} takeSessionFromCtx />
      <Switch>
        <Route exact path={`${path}/`}>
          <VStack spacing={3} align="stretch">
            <Header
              showLanguage
              title={formatMessage({
                defaultMessage: "Checkout",
                description: "Header title",
              })}
              onCloseButtonClick={isCancellable && handleCancel}
            />
            <CheckoutContainer
              onSubmitting={handleSubmitting}
              onCancel={handleCancel}
              onComplete={onComplete}
              enableAutoRedirect={!viewedAddPM}
              onAddPMOpen={onAddPMOpen}
              onAddPMClose={onAddPMClose}
              {...rest}
            />
          </VStack>
        </Route>
        <Route path={`${path}/addpm`}>
          <AddPaymentMethodContent
            onComplete={onAddPMClose}
            onCancel={onAddPMClose}
            chooserConfig={chooserConfig}
            description={formatMessage({
              defaultMessage:
                "To proceed with the checkout process, please begin by adding a payment method.",
              description: "Sub header",
            })}
          />
        </Route>
      </Switch>
    </IframeOrFullPageWrapper>
  );
};
